// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Rz2zGDki","title":"VevEm0Ch","md":"tRiiD2Q4","lg":"RVCzNc_p"};